import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M8 16.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0","key":"svg-1"}],["path",{"d":"M13 12.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0","key":"svg-2"}],["path",{"d":"M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2","key":"svg-3"}],["path",{"d":"M9.5 15a2.5 2.5 0 0 1 2.5 -2.5h1","key":"svg-4"}]]

const IconFileVector = createReactComponent('outline', 'file-vector', 'FileVector', __iconNode);

export default IconFileVector;